"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OperatorString = void 0;
const AbstractStringElement_1 = require("./AbstractStringElement");
const ParenthesisClose_1 = require("./ParenthesisClose");
const ParenthesisOpen_1 = require("./ParenthesisOpen");
const NotString_1 = require("./NotString");
class OperatorString extends AbstractStringElement_1.AbstractStringElement {
    static getMatcher() {
        return /^ ?(OR|AND|)(?= +|$)/;
    }
    getOperator() {
        if (this.parsedString.includes('OR')) {
            return 'OR';
        }
        if (this.parsedString.includes('AND')) {
            return 'AND';
        }
    }
    getLeftHandOperand() {
        const previousElement = this.getPrevious();
        if (previousElement instanceof ParenthesisClose_1.ParenthesisClose) {
            return [
                previousElement.getOpeningParenthesis(),
                ...previousElement.getParenthesisContent().asArray(),
                previousElement,
            ];
        }
        return [previousElement];
    }
    getRightHandOperand() {
        let nextElement = this.getNext();
        if (nextElement instanceof NotString_1.NotString) {
            nextElement = nextElement.getNext();
        }
        if (nextElement instanceof ParenthesisOpen_1.ParenthesisOpen) {
            return [
                nextElement,
                ...nextElement.getParenthesisContent().asArray(),
                nextElement.getClosingParenthesis(),
            ];
        }
        return [nextElement];
    }
}
exports.OperatorString = OperatorString;
//# sourceMappingURL=OperatorString.js.map